export enum VersionApiErrorTypes {
  ServiceUnavailableError,
  BadRequestError,
  NotFoundError,
}

export class VersionApiError {
  constructor(public type: VersionApiErrorTypes, public error: Error) {}
}
